import BacnetObjectDefinition from "./BacnetObjectDefinition";

export default class BacnetObjectsReadValuesRequestModel {
  public readonly bacnetObjectDefinitions: BacnetObjectDefinition[];

  constructor(bacnetObjectDefinitions: BacnetObjectDefinition[]) {
    this.bacnetObjectDefinitions = bacnetObjectDefinitions;
  }
}
